var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-content"},[(_vm.$route.name === 'administration:shipments')?_c('select-bundle',{on:{"select":function($event){return _vm.select($event)}}}):_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-header-title"},[_vm._v("Manage Bundles/Shipments")])])
}]

export { render, staticRenderFns }